/**
 * Created by neo on 07.03.22.
 */
import { makeAutoObservable } from 'mobx';
import { LocalizedEntity, createLocalizedEntity } from '../LocalizedEntity';
import { Media, createMedia } from '../Media/Media';

export type ExploreCategoryLink = LocalizedEntity & {
  link: string;
  params: Record<string, string>;
  image?: Media;
};

export function createExploreCategoryLink(json?: Partial<ExploreCategoryLink>): ExploreCategoryLink {
  const base = createLocalizedEntity(json);
  return makeAutoObservable({
    ...base,
    link: json?.link ?? '',
    params: json?.params ?? {},
    image: json?.image ? createMedia(json.image) : undefined,
  });
}
